import Navigation from "../components/Navigation";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Landing() {
    return (
        <main data-testid="landing-page" className="relative">
            <Navigation />
            <Hero />
            <Services />
            <Contact />
            <Footer />
        </main>
    );
}
